/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { faMicrophone, faSave, faTimes } from '@fortawesome/free-solid-svg-icons';
import { PATH_DEFAULT, PATH_FILE_DETAILS } from '../../../routes';
import { RECORDING_STATUS, DELETE_RECORDING } from '../../../constants/constants';
import { getRecordFile } from '../../helpers/recorder.helpers';
import Button from '../../../common/components/button/button.component';
import './recorder-footer.style.css';
import commonStore from '../../../common/stores/common.store';

/**
 * Class representing the recorder footer component.
 * @extends Component
 * */
class RecorderFooter extends Component {

  static propTypes = {
    createMessage: PropTypes.func.isRequired,
    openConfirmation: PropTypes.func,
    push: PropTypes.func.isRequired,
    recordBlob: PropTypes.shape({}),
    setStatus: PropTypes.func.isRequired,
    startTimer: PropTypes.func.isRequired,
    status: PropTypes.string.isRequired,
  };


  static defaultProps = {
    openConfirmation: () => { },
    recordBlob: null,
  };

  isSave = false;

  componentWillUnmount() {
    const { setStatus } = this.props;

    // When the Recorder component is unmounted the record state should be canceled.
    if (!this.isSave) {
      setStatus(RECORDING_STATUS.WAITING);
    }
  }

  /**
   * Restarts the recording.
   * */
  onTryAgain = () => {
    const { startTimer, setStatus } = this.props;
    commonStore.showSpinner();
    setStatus(RECORDING_STATUS.WAITING);
    startTimer();
  };

  /**
   * Cancel the recording.
   * */
  onCancel = () => {
    const { push } = this.props;

    push(PATH_DEFAULT);
  };

  /**
   * Saves the recording.
   * */
  onSave = async () => {
    const {
      createMessage,
      push,
      recordBlob,
      setStatus
    } = this.props;

    const file = getRecordFile(recordBlob);
    setStatus(RECORDING_STATUS.WAITING);
    this.isSave = true;

    if (file) {
      const result = await createMessage(file);
      if(result){
        push(`${PATH_FILE_DETAILS}/${result.id}`);
      }
    }
  };

  /**
   * If user pre-recorder an audio, opens the confirmation popup and calls cancel handler if user click on continue.
   * */
  handleCancel = () => {
    const { openConfirmation, recordBlob } = this.props;
    if (!recordBlob) {
      this.onCancel();
      return;
    }
    openConfirmation(DELETE_RECORDING, this.onCancel);
  };

  /**
   * Opens the confirmation popup and calls try again handler if user clicks on continue.
   * */
  handleTryAgain = () => {
    const { openConfirmation } = this.props;

    openConfirmation(DELETE_RECORDING, this.onTryAgain);
  };

 
  render() {
    const { status } = this.props;

      return (
        <div className="recorder-footer text-center">
          {status !== RECORDING_STATUS.RECORDING && (
            <Button
              buttonClass="btn btn-link btn-secondary btn-cancel"
              fontAwesomeIcon={faTimes}
              onButtonClick={this.handleCancel}
              title="Cancel"
            />
          )}
          {(status === RECORDING_STATUS.RECORDED
            || status === RECORDING_STATUS.PLAYING)
            && (
              <div>
                <Button
                  buttonClass="btn btn-link btn-secondary btn-save"
                  fontAwesomeIcon={faSave}
                  onButtonClick={this.onSave}
                  title="Save"
                />
                <Button
                  buttonClass="btn btn-link btn-secondary btn-retry"
                  fontAwesomeIcon={faMicrophone}
                  onButtonClick={this.handleTryAgain}
                  title="Retry"
                />
              </div>
            )}
        </div>
      );
  }

}

export default RecorderFooter;



// WEBPACK FOOTER //
// ./src/messages/recorder/recorder-footer/recorder-footer.component.js